<div class="header border-bottom">
  <div class="container-1">
    <div class="d-flex flex-row align-items-center">
      <div class="logo col-lg-9 col-md-6 col-9 ps-md-0 d-flex flex-row align-items-center">
        <a href="//ups.com"><img class="ups-shield" src="/assets/UPS_Flat_Logo.svg" alt="UPS.com"></a>
        <h4 class="trailer-reservation-suite">{{localize(langSection.Term, langText.TrailerReservationSuite)}}</h4>
        @if (showHeaderMenu) {
<div class="col-md-8 col-sm-3 menu-container">
          @for (menu of menus; track menu; let i = $index) {
<div class="menus" [ngClass]="selectedMenu == i ? 'selected-menu' : ''" (click)="toggleSubMenu(i, $event)">
            {{menu.label}}
          </div>
}
          @if (showNcmLink) {
<a class="menus ncm-link" (click)="onNcmLinkClick()">{{localize(langSection.Term, langText.NetworkCarrierManagement)}}</a>
}
        </div>
}
      </div>
      <div class="col-lg-3 col-md-6 col-3 d-inline-flex justify-content-end pe-3 pe-lg-0">
        <div class="d-flex flex-end align-items-center justify-content-end language-link pe-sm-4 pe-3" role="button" (click)="showLanguageMenuClick()">
          <span [ngClass]="showLanguageMenu ? 'show' : ''" class="icon globe"></span>
          <span class="icon-text">{{localize(langSection.Language, langText.Locality)}} - {{localize(langSection.Language, langText.Name)}}</span>
        </div>
        @if (loggedIn) {
<div class="d-flex flex-end align-items-center justify-content name personal-link pe-lg-0 pe-sm-3" role="button"
          (click)="showPersonalMenuClick()">
          <button class="dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown">
            <span>{{abbreviatedName}}</span>
          </button>
        </div>
}
        @if (!loggedIn) {
<div class="d-flex flex-end align-items-center justify-content signup" role="button" (click)="goToSignup()">
          <span class="icon user"></span>
          <span class="icon-text ps-2">{{localize(langSection.Header, langText.SignUp)}}</span>
        </div>
}
        @if (showHeaderMenu) {
<div class="menu-hamburger ups-icon ps-xs-0" [ngClass]="expandMenu ? 'ups-icon-x' : 'ups-icon-menu'" role="button"
          (click)="onHamburgerClick()"></div>
}
        @if (expandMenu) {
<div class="menu-hamburger-dropdown-container">
          @for (menu of menus; track menu; let i = $index) {

            <div class="menu-hamburger-toggle" role="button" [ngClass]="selectedMenu == i ? 'selected-menu' : ''" (click)="toggleHamburgerSubMenu(i, $event)">
              {{menu.label}}
              <span class="ups-icon" [ngClass]="selectedMenu === i ? 'ups-icon-chevron-up' : 'ups-icon-chevron-down'"></span>
            </div>
            @if (selectedMenu === i) {

              @for (submenu of menus[i].submenus; track submenu) {

                <div class="menu-submenu-header">{{submenu.label}}</div>
                @for (link of submenu.links; track link) {
<button class="btn btn-link link" (click)="onLinkClick(link)">
                  {{link.label}}
                  <span class="ups-icon ups-icon-chevron-right"></span>
                </button>
}
              
}
            
}
          
}
          @if (showNcmLink) {
<a class="menu-hamburger-toggle" (click)="onNcmLinkClick()">{{localize(langSection.Term, langText.NetworkCarrierManagement)}}</a>
}
          <div class="hamburger-language-divider"></div>
          <div class="menu-hamburger-toggle" role="button" (click)="showLanguageMenuClick(); $event.stopPropagation()">
            {{isFrench ? 'Canada - Français' : 'United States - English'}}
            <span class="ups-icon" [ngClass]="showLanguageMenu ? 'ups-icon-chevron-up' : 'ups-icon-chevron-down'"></span>
          </div>
          @if (showLanguageMenu) {

            <a class="link" (click)="onHamburgerLanguageClick('en')">United States - English</a>
            <a class="link" (click)="onHamburgerLanguageClick('fr')">Canada - Français</a>
          
}
        </div>
}
      </div>
    </div>
  </div>
  @if (subMenuVisible) {
<div class="submenu-container">
    @for (submenu of menus[selectedMenu].submenus; track submenu) {

      @if (submenu.links.length > 0) {
<div class="submenu d-flex flex-column">
        <div class="submenu-label">{{submenu.label}}</div>
        @for (link of submenu.links; track link) {
<div class="d-flex flex-row align-items-center">
          <button class="btn btn-link link pl-0" (click)="onLinkClick(link)">
            {{link.label}}
            <span class="ups-icon ups-icon-chevron-right"></span>
          </button>
        </div>
}
      </div>
}
    
}
  </div>
}
</div>

<div [ngClass]="showPersonalMenu ? 'show' : ''" class="links-bubble personal-links-bubble personal-menu">
  <div class="personal-links">
    <a class="btn btn-link links" (click)="menuClick('profile')">{{localize(langSection.Header, langText.ProfileOverview)}}</a>
    <a class="btn btn-link links" (click)="menuClick('info')">{{localize(langSection.Header, langText.MyInformation)}}</a>
    <a class="btn btn-link links" (click)="menuClick('add')">{{localize(langSection.Header, langText.Addresses)}}</a>
    <a class="btn btn-link links" (click)="menuClick('acc')">{{localize(langSection.Header, langText.AccountsPayment)}}</a>
    <a class="btn btn-link links" (click)="menuClick('pref')">{{localize(langSection.Header, langText.Preferences)}}</a>
    <hr />
    <a type="button" class="btn btn-link links" (click)="menuClick('view')">{{localize(langSection.Header, langText.ViewPayBill)}}</a>
    <hr />
    <a class="btn btn-link links" (click)="menuClick('logout')">{{localize(langSection.Header, langText.LogOut)}}</a>
  </div>
</div>

<div [ngClass]="showLanguageMenu ? 'show' : ''" class="links-bubble language-links-bubble language-menu">
  <div class="language-links">
    <a class="btn btn-link links" (click)="setLanguage('en')">United States - English</a>
    <a class="btn btn-link links" (click)="setLanguage('fr')">Canada - Français</a>
  </div>
</div>